{
	"add-trackingnumber": "Bæta við sendingarnúmeri",
	"confirm-trackingnumber": "Staðfesta sendingarnúmer",
	"contentDescription": "Innihaldslýsing",
	"contentsDescription": "Hér skal rita innihaldslýsingu eða aðrar upplýsingar um sendinguna (255 stafir)",
	"content-max": "Innihaldslýsingin má ekki vera lengri en 255 stafir",
	"delivery": "Afhending",
	"email": "Netfang viðtakanda",
	"email-invalid": "Netfang er ekki á réttu formi",
	"enter-shipment-code": "Sláðu inn sendingarnúmer",
	"errorWithTrackingnumber": "Sendingarnúmer á vitlausu sniði",
	"evaluateDescription": "Leiðbeiningar til Póstsins",
	"file-min": "Verður að bæta við skjali",
	"foreign-social-id": "Ég er ekki með íslenska kennitölu",
	"gift": "Sendingin er gjöf (gefa þarf Tollstjóra upp tilefni gjafar í reitnum upplýsingar um sendingu)",
	"hasBeenPayed": "Búið er að greiða fyrir sendingu og því ekki hægt að fá endurmat",
	"iDontHaveReceipt": "Ég hef ekki reikning/kvittun, eða sendingin er gjöf",
	"ifWeNeedMore": "Ef þörf er á nánari gögnum og/eða upplýsingum frá þér munum við vera í sambandi við þig innan 2 virka daga.",
	"iHaveReceipt": "Ég hef reikning/kvittun",
	"infoText": "Athugið ef sendingarnúmer byrjar á PR og endar á YP fær sendingin nýtt númer á leið til landsins, hægt er að sjá nýja númerið á ",
	"infoTextLink": "www.packageradar.com",
	"infoTextPhone": "Mikilvægt er að bæta við GSM til að fá tilkynningar og einnig til að sendingar geti farið í Póstbox eða Pakkaport",
	"instructions": "Leiðbeiningar til Póstsins",
	"moreThanOneTrackingnumber": "Athugaðu: Hægt er að senda inn fleiri en eitt sendingarnúmer.",
	"name": "Nafn viðtakanda",
	"upsell": "Einfaldaðu ferlið við móttöku sendinga með því að skrá þig í sjálfvirkar greiðslur og Póstbox á ",
	"upsell2": "Mínum síðum.",
	"next-step": "Næsta skref",
	"notArrived": "Sending er ekki komin á tollalager",
	"notFound": "Sendingarnúmer fannst ekki, reyndu aftur",
	"notInStock": "Sending er farin af tollalager",
	"other": "Annað (gefa upp skýringu í reitnum upplýsingar um sendingu. Ef óskað er eftir að Pósturinn opni eða skoði sendinguna, þá áskilur Pósturinn sér rétt til að rukka fyrir það 990 kr)",
	"permissionToOpen": "Ég gef Póstinum leyfi til að opna sendingu í leit að reikning/upplýsa um innihald (990 kr.)",
	"phone": "Farsímanúmer viðtakanda",
	"phone-invalid": "Símanúmerið er ekki á réttu formi",
	"phone-max": "Símanúmer má ekki vera lengra en sjö stafir",
	"phone-min": "Símanúmerið verður að vera minnst sjö stafir",
	"processTime": "Sendingin verður tollafgreidd og að því loknu fer sendingin beint í afhendingarferli.",
	"required": "Skylda að fylla út",
	"social-id": "Kennitala viðtakanda",
	"ssn-min": "Kennitala verður að vera minnst 10 stafir",
	"ssn-valid": "Kennitala er ekki rétt - Aðeins tölustafir eru leyfðir, ekkert bil eða bandstrik",
	"submit": "Ganga frá beiðni",
	"trackingnumber-min": "Verður að bæta við að minnsta kosti einu sendingarnúmeri",
	"get-shipment": "Sækja sendingu",
	"info": "Með því að fylla út þessa beiðni veitir þú Póstinum heimild til að sjá um tollafgreiðslu á sendingunni þinni. Ef sending er yfir 40 þúsund kr. þá fer hún sjálfkrafa í E1 skýrslugerð ",
	"seeCalculator": "sjá reiknivél",
	"info2": "Ef beiðnin berst fyrir kl. 11:30 getur þú óskað eftir flýtiþjónustu og fengið sendinguna heimsenda eða á pósthús samdægurs á höfuðborgarsvæðinu eða nálgast hana síðar sama dag í Póstmiðstöðinni. Sendingin berst næsta virkan dag ef beiðnin er gerð eftir kl. 11:30, eða ef þú býrð utan höfuðborgarsvæðisins. Þá berst sendingin á þann afhendingarstað sem þú valdir upphaflega.",
	"validReceipt": "Til þess að reikningur sé fullnægjandi þarf að koma fram vörulýsing, heildarverð og flutningskostnaður.",
	"name-invalid": "Nafn ekki á réttu formi"
}
